import React from 'react';
import { Skeleton } from '@mui/material';

export default function ListSkeleton() {
  return <Skeleton sx={{ flexGrow: 1, height: 'auto' }}></Skeleton>;
}
